import { render, staticRenderFns } from "./tag_maintain.vue?vue&type=template&id=45aa4abe&scoped=true"
import script from "./tag_maintain.vue?vue&type=script&lang=js"
export * from "./tag_maintain.vue?vue&type=script&lang=js"
import style0 from "./tag_maintain.vue?vue&type=style&index=0&id=45aa4abe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa4abe",
  null
  
)

export default component.exports